/**
 * Meta keeps one copy when a Pixel event and a Conversions API event share event_name and event_id,
 * so the browser and server must build these IDs the same way. The browser payment code and the
 * StartTrial queue (backend-cloud migration `meta_conversions`) use the same formats.
 */
export const conversionEventId = {
  signup: (userId: string) => `signup:${userId}`,
  firstCall: (orgId: string) => `first_call:${orgId}`,
  purchase: (transactionId: string) => `purchase:${transactionId}`,
};

/** Browser milestones the server re-checks before sending the matching Conversions API event. */
export type ConversionMilestone = 'account_created';
